export const whiteFilter =
  'invert(60%) sepia(100%) saturate(2%) hue-rotate(98deg) brightness(200%) contrast(101%)';

export const blackFilter =
  'invert(97%) sepia(0%) saturate(0%) hue-rotate(136deg) brightness(50%) contrast(100%);';
